// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1Vd4d","head":"ProcedureTableInfo_head__21kJQ"};